import { useRef } from "react";
import { Typography, Box, Container } from "@mui/material";
import { motion, useInView } from "framer-motion";

import AboutScroller from "../../compontents/about/AboutScroller";
import { studioHighlights, studioStats } from '../../compontents/about/StudioOverview';

import TopSection from "../../compontents/common/TopSection";
import MainSection from "../../compontents/common/MainSection";
import './about.css';

export default function AboutPage() {
    return (
        <>
            <TopSection 
                title={"Broadcast Studio"}
                desc="Supporting amplification of regional voices, bridging communities, 
                    and championing creative collaboration + storytelling"
                contentTranslateY={27}
            />

            <MainSection paddingAmount="120px 0 40px">
                <Container maxWidth="lg">
                    <AboutScroller 
                        specificDataFrom={"about"}
                        animationOn={true} 
                    />
                </Container>

                <Container maxWidth="lg" sx={{ py: 12, mt: '80px' }}>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr", lg: "repeat(4, 1fr)" },
                            gap: '68px',
                            textAlign: "left",
                            justifyItems: { xs: "center", md: "start" }, 
                            ml: { xs: 0, md: '-30px' },
                        }}
                    >
                        {studioStats.map((item) => (
                            <Box
                                key={item.id}
                                className="stats"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    minHeight: '160px', 
                                }}
                            >
                                <Typography className="amount" sx={{ mb: 1 }}>
                                    {item.amount}
                                </Typography>
                                <Typography className="description" sx={{ mt: 1 }}>
                                    {item.description}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Container>

                <Container maxWidth="xl" sx={{ py: 12, index: 4 }}>
                    <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', mt: 6 }}>
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                                gap: 4,
                            }}
                        >
                            {studioHighlights.map((item) => {
                                const ref = useRef(null);
                                const inView = useInView(ref, { once: true, margin: '-100px' });

                                return (
                                    <motion.div
                                        key={item.id}
                                        ref={ref}
                                        initial={{ opacity: 0, y: 40 }}
                                        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                                        transition={{ duration: 0.6, ease: 'easeOut' }}
                                    >
                                        <Box sx={{ p: 3 }}>
                                            <Typography variant="body2" sx={{ color: 'gray' }}>
                                                {item.id}
                                            </Typography>
                                            <Typography sx={{ mt: 1, mb: 1, fontSize: '26px' }}>
                                                {item.title}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    mt: 3,
                                                    lineHeight: '180%',
                                                    fontSize: { xs: '16px', md: '22px' },
                                                    color: 'rgb(128, 128, 128)',
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </Box>
                                    </motion.div>
                                );
                            })}
                        </Box>
                    </Box>
                </Container>
            </MainSection>
        </>
    );
}
